export default class GoogleMapsApi {
  constructor(callbackName) {
    callbackName = callbackName || '_GoogleMapsApi';
    this.callbackName = `${callbackName}.mapLoaded`;
    if (!window[callbackName]) {
      window[callbackName] = this;
      window[callbackName].mapLoaded = this.mapLoaded.bind(this);
    }
  }

  /**
   * Load the Google Maps API javascript
   * @param {string} apiKey
   * @return {Promise}
   */
  load(apiKey) {
    if (!this.promise) {
      this.promise = new Promise((resolve) => {
        this.resolve = () => {
          $(document).trigger('LoadGoogleApiDone');
          resolve();
        };
        if (typeof window.google === 'undefined' && !window.loadingGoogleApi) {
			window.loadingGoogleApi = true;
			$.getScript(`https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places`)
			.done(() => {
				window.loadingGoogleApi = false;
				// eslint-disable-next-line no-undef
				if (!window.sessionToken) window.sessionToken = new google.maps.places.AutocompleteSessionToken();
				if (!window.autocompleteOK) window.autocompleteOK = window.google.maps.places.PlacesServiceStatus.OK;
				this.resolve();
			})
			.fail(() => {
				// failed
				// console.log('failed');
				window.loadingGoogleApi = false;
			});
        } else {
          this.resolve();
        }
      });
    }
    return this.promise;
  }

  /**
   *
   * @param {string} query
   * @param {object} options - AutoCompleteServiceRequest
   * @return {Promise}
   */
  getPlacePredictions(query, options) {
    return new Promise((resolve, reject)=> {
      if (!window.google) resolve([]);
      else {
        if (!window.autocompleteService) window.autocompleteService = new window.google.maps.places.AutocompleteService();
        const _request = Object.assign({}, {
			input: query,
			sessionToken: window.sessionToken,
		}, options);
        window.autocompleteService.getPlacePredictions(
            _request,
            (predictions, status)=> {
				if (status !== window.autocompleteOK) {
					reject({predictions, status});
					return;
				}
	        	resolve({predictions, status});
	    	});
      }
    });
  }

  /**
   *
   * @param {object} location
   * @param {object} geocoder
   * @return {Promise}
   */
  getPlaceDetailByLocation(location, geocoder) {
    geocoder = geocoder || new window.google.maps.Geocoder();
    // return geocoder.geocode({location: location});
	return new Promise((resolve, reject)=> {
		if (!window.google) resolve([]);
		else {
			geocoder.geocode({location: location}, (response, status)=> {
				if (status !== window.autocompleteOK) {
					reject();
					return;
				}
	        	resolve({response, status});
	    	});
		}
	});
  }

  /**
   * Globally scoped callback for the map loaded
   */
  mapLoaded() {
    if (this.resolve) {
      this.resolve();
    }
  }
}

export const LOAD_GOOGLE_API_DONE = 'LoadGoogleApiDone';



// WEBPACK FOOTER //
// ./googleMapsApi.js